import { Col, Input, Row, Select } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { t } from 'i18next';
import React from 'react';
import PrimaryButton from '../../../../component/button/PrimaryButton';
import SecondaryButton from '../../../../component/button/SecondaryButton';
import Breadcumbs from '../../../../component/page-components/breadcumbs/breadcumbs';
import HeaderPages from '../../../../component/page-components/pages-header';
import useAddTemperature from './add-temperature.hooks';
import NotifAddSuccess from '../../../../component/modal/NotifAddSuccess';
import NotifFailedSaved from '../../../../component/modal/NotifFailedSaved';
import { ROUTES } from '../../../../constant/routeConstant';
import ModalConfirmLeave from "../../../../component/modal/ModalConfirmLeave";

const AddTemperature = () => {
  const {
    list,
    backToList,
    _onChange,
    error,
    err,
    form,
    onSubmit,
    successModalOpen,
    _onOkSuccesAdd,
    failedModalOpen,
    messageFailed,
    setFailedModalOpen,
    setShowConfirm,
    showConfirm
  } = useAddTemperature();

  return (
    <>
      <div className='p-5 h-fit'>

        <ModalConfirmLeave
          visible={showConfirm}
          action={() => setShowConfirm(false)}
          route={ROUTES.TEMPERATURE_CATEGORY.LIST}
        />

        <Breadcumbs
          jmlLevel={4}
          menuLevel1={`Setup`}
          menuLevel2={`Profile Configuration`}
          menuLevel3={`Temperature Category`}
          menuLevel4={`Add Temperature Category `}
        />
        <HeaderPages
          title="Add Temperature Category"
          menuType="add"
          handleBack={backToList}
        />
        <div className=' bg-white-100 p-5 rounded-[10px] h-96'>
          <p className=' font-roboto text-lg text-black-100 font-bold'>
            Detail to Add Temperature Category
          </p>
          <Row className='mt-5'>
            <Col span={12}>
              <div>
                <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                  {t("Category Name")}
                </p>
                <Input
                  style={{ width: '50%' }}
                  size='large'
                  onChange={(evt) => { _onChange(evt, 'name') }}
                  placeholder={t("COMMON:TYPE", { field: t("Category Name") })}
                  status={error?.name ? 'error' : null}
                />
              </div>
              <div className="text-red-100">
                {err ? err : error?.name}
              </div>
              <div>
                <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                  {t("Temperature Code")}
                </p>
                <Select
                  style={{ width: '50%' }}
                  size='large'
                  options={list}
                  value={form?.uom_id}
                  onChange={(evt) => { _onChange(evt, 'uom_id') }}
                  placeholder={t("COMMON:SELECT", { field: t("Temperature Code") })}
                  status={error?.code ? 'error' : null}
                />
              </div>
              <div className="text-red-100">
                {err ? err : error?.code}
              </div>
              <div className='mt-2'>
                <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                  {t("DATA_GROUP:LBL_DESCRIPTION")}
                </p>
                <TextArea
                  style={{ width: '50%' }}
                  size='large'
                  onChange={(evt) => { _onChange(evt, 'description') }}
                  placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_ADDRESS") })}
                  status={error?.description ? 'error' : null}
                />
              </div>
              <div className="text-red-100">
                {err ? err : error?.description}
              </div>
            </Col>
            <Col span={12}></Col>
          </Row>
        </div>
      </div>
      <div className='flex flex-row-reverse gap-[16px] px-5 m-5'>
        <PrimaryButton action={onSubmit} text={t("USER_DETAIL:SAVE")} />
        <SecondaryButton action={backToList} text={t("COMMON:BACK")} />
      </div>
      <NotifAddSuccess
        visible={successModalOpen}
        menu={form?.name}
        action={_onOkSuccesAdd}
      />
      <NotifFailedSaved
        visible={failedModalOpen}
        message={messageFailed}
        action={() => { setFailedModalOpen(false) }}
      />
    </>
  );
}

export default AddTemperature;